export function MedicalEquipment() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.83398 1.83032V0.580322C1.14363 0.580322 0.583984 1.13997 0.583984 1.83032L1.83398 1.83032ZM11.9173 1.83032H13.1673C13.1673 1.13997 12.6077 0.580322 11.9173 0.580322V1.83032ZM10.5423 0.580322C9.85196 0.580322 9.29232 1.13997 9.29232 1.83032C9.29232 2.52068 9.85196 3.08032 10.5423 3.08032V0.580322ZM3.20898 3.08032C3.89934 3.08032 4.45898 2.52068 4.45898 1.83032C4.45898 1.13997 3.89934 0.580322 3.20898 0.580322V3.08032ZM10.6673 1.83032V7.78866H13.1673V1.83032H10.6673ZM3.08398 7.78866V1.83032H0.583984V7.78866H3.08398ZM11.9173 0.580322H10.5423V3.08032H11.9173V0.580322ZM1.83398 3.08032H3.20898V0.580322H1.83398V3.08032ZM6.87565 11.5803C4.78157 11.5803 3.08398 9.88273 3.08398 7.78866H0.583984C0.583984 11.2634 3.40086 14.0803 6.87565 14.0803V11.5803ZM10.6673 7.78866C10.6673 9.88273 8.96973 11.5803 6.87565 11.5803V14.0803C10.3504 14.0803 13.1673 11.2634 13.1673 7.78866H10.6673Z"
        fill="#D0D3DC"
      />
      <ellipse
        cx="18.1035"
        cy="9.85376"
        rx="2.0625"
        ry="2.0625"
        stroke="#D0D3DC"
        strokeWidth="2.5"
      />
      <path
        d="M16.8542 11.9163V14.5517H19.3542V11.9163H16.8542ZM8.125 14.5517V12.8329H5.625V14.5517H8.125ZM12.4896 18.9163C10.0791 18.9163 8.125 16.9622 8.125 14.5517H5.625C5.625 18.3429 8.69838 21.4163 12.4896 21.4163V18.9163ZM16.8542 14.5517C16.8542 16.9622 14.9001 18.9163 12.4896 18.9163V21.4163C16.2808 21.4163 19.3542 18.3429 19.3542 14.5517H16.8542Z"
        fill="#D0D3DC"
      />
    </svg>
  );
}
